export const AVATAR_LOCALE_ZHCHS = {
    imgtitle: 'ç¹å»ä¿®æ¹',
    typeError: 'ä¸ä¼ å¾çç±»åä¸æ­£ç¡®',
    sizeError: 'ä¸ä¼ å¾çä¸è½å¤§äº',
    uploadError: 'å¾çä¸ä¼ å¤±è´¥ï¼è¯·éè¯!',
    loadError: 'å è½½éè¯¯'
};